export default "<h1>Type7Time list</h1>\n<spec-app-type7-time-table [clickHandler]=\"createClickHandler()\"></spec-app-type7-time-table>";